import React, { useState } from 'react';
import { uuid } from '../../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../../Legacy';
import { Colors } from '../../../../ui';
import { RenderSvg } from '../../../canvas/visualization/RenderHelpers';
import { FrameBorderWidthAttr } from '../FrameAssociations';
import { GridFrameAddon } from './GridFrameAddon';

export const GridFrameAddonVisual: LFC<{ object: GridFrameAddon }> = ({ object }) => {
    const { base, pattern } = object.layout;

    const lw = FrameBorderWidthAttr.get(object.parentFrame) / 3 * 1;
    const lwa = 1;
    const color = Colors.contrastColorFor(object.parentFrame.background, { dark: Colors.gray400 });

    const [[g1]] = useState([uuid(), uuid(), uuid()]);
    const [[p1, p2, p3, p4]] = useState([uuid(), uuid(), uuid(), uuid()]);

    return <>
        <RenderSvg area={base}>
            <defs>
                {/* Columns */}
                <pattern id={p1} x={pattern.width / -2} y={0} width={pattern.width} height={10} patternUnits="userSpaceOnUse" >
                    <line x1={pattern.x} y1="0" x2={pattern.x} y2="100%" stroke={color} strokeWidth={lw} strokeLinecap="round" />
                </pattern>
                {/* Rows */}
                <pattern id={p2} x={0} y={pattern.height / -2} width={10} height={pattern.height} patternUnits="userSpaceOnUse">
                    <line x1="0" y1={pattern.y} x2="100%" y2={pattern.y} stroke={color} strokeWidth={lw} strokeLinecap="round" />
                </pattern>
            </defs>
            <g>
                <rect {...base.toObject('xy')} fill={`url(#${p1})`} />
                <rect {...base.toObject('xy')} fill={`url(#${p2})`} />
            </g>
        </RenderSvg>
    </>;
};
